import { Box, Stack, styled } from '@ltvco/refresh-lib/theme';

import { SectionCard } from '../../shared';

export const SectionStack = SectionCard;

export const DetailListItemBox = styled(Box)({
  display: 'list-item',
});

export const JudgeDetailsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
  marginTop: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(0, 1),
  },
}));

export const PositionCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius,
}));

export const PositionDetailsList = styled(Stack)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  listStyleType: 'disc',
}));
